import {Field} from "./Field";

export class FileField extends Field<File> {
    stringValue = (): string | undefined => {
        if (this.value) {
            return this.value.toString();
        }
        return undefined
    };
}